module.exports = __webpack_public_path__ + "img/logo.de2a1787.png";